document.addEventListener('DOMContentLoaded', () => {
    const quickAddButtons = document.querySelectorAll('.js-quick-add-plus-btn');

    quickAddButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault(); 
            
            // Verifica la disponibilità (Se non disponibile, esce)
            if (button.dataset.isAvailable === 'false') {
                return; 
            }

            const variantId = button.dataset.variantId;
            
            button.disabled = true; 
            button.classList.add('loading'); 

            // PRIMA CHIAMATA AJAX: Aggiunge il prodotto al carrello
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: 1
                    }]
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log('Prodotto aggiunto via +:', data);
                
                // --- NUOVA LOGICA DI AGGIORNAMENTO DEL CARRELLO ---
                
                // 1. Invio di un evento per l'apertura del carrello laterale/notifica del tema Radiant
                document.dispatchEvent(
                    new CustomEvent('cart:add', {
                        bubbles: true,
                        detail: {
                            cart: data // Passa i dati del carrello aggiornato
                        }
                    })
                );
                
                // 2. Aggiornamento manuale del conteggio (badge) del carrello
                fetch('/cart.js')
                    .then(response => response.json())
                    .then(cartData => {
                        // Cerca l'elemento del contatore del carrello in alto (es. header)
                        // A seconda del tema, la classe o la struttura potrebbero variare.
                        // Usiamo un selettore comune per il badge del carrello
                        const badge = document.querySelector('.header__icon--cart .cart-count-bubble, .header-cart-count, .cart-count');
                        
                        if (badge) {
                            badge.innerHTML = cartData.item_count;
                            // Assicurati che il badge sia visibile se il conteggio è > 0
                            if (cartData.item_count > 0) {
                                badge.classList.remove('hidden', 'is-empty');
                            } else {
                                badge.classList.add('hidden', 'is-empty');
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Errore durante il recupero dei dati del carrello:', error);
                    });
                
            })
            .catch(error => {
                console.error('Errore nell\'aggiunta al carrello:', error);
                alert('Si è verificato un errore durante l\'aggiunta al carrello.');
            })
            .finally(() => {
                button.disabled = false;
                button.classList.remove('loading');
            });
        });
    });
});